module.exports = __webpack_public_path__ + "media/theme/border-4-f53e08c7.png";